__turbopack_context__.v({
  "badgeButton": "-mAQuW_badgeButton",
  "badgeEmpty": "-mAQuW_badgeEmpty",
  "cover": "-mAQuW_cover",
  "coverHat": "-mAQuW_coverHat",
  "group": "-mAQuW_group",
  "hat": "-mAQuW_hat",
  "invite": "-mAQuW_invite",
  "inviteActions": "-mAQuW_inviteActions",
  "inviteBody": "-mAQuW_inviteBody",
  "inviteTitle": "-mAQuW_inviteTitle",
  "notNow": "-mAQuW_notNow",
});
